export const CHANNEL = '__glamorous__'
